var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99927 7.99714C1.99927 9.1834 2.35104 10.343 3.01009 11.3294C3.66915 12.3157 4.60588 13.0845 5.70185 13.5384C6.79782 13.9924 8.00379 14.1112 9.16726 13.8798C10.3307 13.6483 11.3995 13.0771 12.2383 12.2383C13.0771 11.3995 13.6483 10.3307 13.8798 9.16726C14.1112 8.00379 13.9924 6.79782 13.5384 5.70185C13.0845 4.60588 12.3157 3.66915 11.3294 3.01009C10.343 2.35104 9.1834 1.99927 7.99714 1.99927C6.32037 2.00558 4.71095 2.65985 3.5054 3.82529L1.99927 5.33142",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99927 1.99927V5.33142H5.33142",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroFilter);
export default __webpack_public_path__ + "static/media/ZeroFilter.e54a9d15dfa518f0b54cf8ec19a76d7a.svg";
export { ForwardRef as ReactComponent };